(() => {
  const cleanup = () => {
    document.querySelectorAll('[data-ao-details-clone]').forEach((node) => node.remove());
    document.querySelectorAll('.ao-details-source--placed').forEach((node) => node.classList.remove('ao-details-source--placed'));
    document.querySelectorAll('[data-ao-mobile-purchase-priority]').forEach((node) => node.remove());
    document.querySelectorAll('[data-ao-mobile-purchase-node]').forEach((node) => node.removeAttribute('data-ao-mobile-purchase-node'));
    document.querySelectorAll('[data-ao-mobile-purchase-anchor]').forEach((node) => node.remove());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup, { once: true });
  } else {
    cleanup();
  }

  document.addEventListener('shopify:section:load', cleanup);
  document.addEventListener('shopify:section:unload', cleanup);
})();
